import { setTypeToggle } from "./_common.js";

const setHeaderBack = () => {
    const back = document.querySelector('.pg-search-terms-header__back');
    if (!back) return;

    back.addEventListener('click', (e) => {
        e.preventDefault();
        window.history.back();
    });
};

const main = () => {
    if (document.querySelector('#page-search-terms') === null) return;
    setHeaderBack();
    // 物件種別トグル（戸建/土地）。選択で種別を変えて同ページへ遷移し、種別に応じた項目を表示する。
    setTypeToggle();
};

export default main;
